module.exports = __webpack_public_path__ + "static/media/grow.16c153c3.svg";